import React, { useContext } from "react";
import { Box, Container, Toolbar, styled } from "@mui/material";
import { ColorModeContext } from "../../constants/theme";

function ContainerLayout({ children, ...styles }) {
  const { mode } = useContext(ColorModeContext);
  /* eslint-disable no-unused-vars */
  const ContainerStyle = React.useMemo(
    () =>
      styled(Box)(({ theme }) => ({
        width: "100%",
        ".container": {
          height: "100%",
          width: "100%",
          maxWidth: "1300px",
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: "50px",
          padding: "40px",
          ...styles,
        },
      })),
    [],
  );
  /* eslint-enable no-unused-vars */

  return (
    <ContainerStyle>
      <Container
        className="container"
        sx={{
          background: `${mode === "dark" ? "#0D0D0D" : "#fff"}`,
        }}
      >
        <Toolbar />
        {children}
      </Container>
    </ContainerStyle>
  );
}

export default ContainerLayout;
